import {DataAttribute} from './data-attribute.model';
import {DataSourceType} from '@app/views/admin/application-settings/models/data-source-type.model';
import {DefaultSchemaName} from '@app/views/admin/application-settings/models/data-source-config.model';
import {Application} from '@app/views/admin/application-settings/models/application.model';
import {PIIShieldAction} from '@app/core/model/integration-models';
import {SensitiveData} from '@app/views/admin/provider/sensitive-data/sensitive-data.model';
import {PII_LEVEL} from '@app/views/admin/application-settings/components/basic/pii-shield-level-info/pii-shield.model';

export class IntegrationTaskMap {
    public mappingIndex: number;
    public duplicatesMappingIds: string[];
    public direction: AttributeMappingDirection;
    public temporaryDirection: AttributeMappingDirection;
    public piiShieldAction: PIIShieldAction;
    public piiLevel: PII_LEVEL;

    constructor(
        public mappingId: string = null,
        public sourcePropertyName: string = '',
        public targetPropertyName: string = '',
        public backToSourcePropertyName: string = '',
        public enabled: boolean = true,
        public taskId: string = '',
        public sourceProperty: DataAttribute = new DataAttribute(),
        public targetProperty: DataAttribute = new DataAttribute()
    ) { }
}

export enum AttributeMappingDirection {
    IMPORT = 'IMPORT',
    EXPORT = 'EXPORT',
    SYNC = 'SYNC'
}

export const ENABLED_CTRL = 'EnabledCtrl';

export class CombinedIntegrationTaskMap extends IntegrationTaskMap {
    public sourceProperties: DataAttribute[];
    public friendlyName: string;
    public dataSourceTypes: DataSourceType[];
    public defaultSchemaNames: DefaultSchemaName[];
    public integrationFriendlyNames: string[];
    public applications: Application[];
    public defaultSchemaNamesOrDataSourceTypes: (DefaultSchemaName | DataSourceType)[];
    public sensitiveData: SensitiveData;
}

